import React from 'react';
import { Description } from '../Description';
import { Header } from '../Header';
import styles from './BasicCard.scss';
export var BasicCard = function BasicCard(props) {
  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();

      if (props.onClick) {
        props.onClick();
      }
    }
  };

  return React.createElement("div", {
    className: styles.basicCard,
    role: "button",
    tabIndex: 0,
    "data-test": props.dataTest,
    onClick: props.onClick,
    onKeyPress: handleKeyPress
  }, props.icon && React.createElement("div", {
    className: styles.icon
  }, props.icon), React.createElement("div", null, React.createElement(Header, {
    variant: "h4",
    dataTest: "title"
  }, props.title), props.content && React.createElement("div", {
    className: styles.content
  }, React.createElement(Description, {
    variant: "condensed",
    dataTest: "content"
  }, props.content))));
};